import React,{Fragment} from 'react'
import {Link} from 'react-router-dom'
function Inicio() {
    return (
        <Fragment>
       
            <div className="container">
                <h2 className="text-center mt-5"> Mini proyecto con Firebase y ReactJS</h2>
                <div className="row mx-auto mt-3">
                    <div className="col-md-6">
                            <h3 className="text-center">Bienvenido al Login ReactJS</h3>
                            <p className="text-justify fs-4">
                                En el cual mostrare un sistema de login con firebase con bootstrap
                                en el cual contiene validacion de usuario en el cual mostrara mensaje de alerta de <b>swalert</b>
                            </p>
                         </div>
                         <div className="col-md-6 text-center">
                         <h3 className="text-center">Para comezar registrate</h3>
                        <div className="row mb-5">
                            <div  className="col-md-4 float-end mx-auto d-block">
                                <Link className="btn btn-outline-success btn-lg" to="/login"> Comenzar</Link>
                            </div>
                            
                        </div>
                    </div>
                </div>
                
            </div>
        </Fragment>
    )
}

export default Inicio
